import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e08de8a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e08de8a')) {
      api.createRecord('4e08de8a', component.options)
    } else {
      api.reload('4e08de8a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e08de8a", function () {
      api.rerender('4e08de8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/Forms/Brand/index.vue"
export default component.exports